import distance from "@turf/distance"
import { point as turfPoint } from "@turf/helpers"
import { DateTime } from "luxon"
import _ from "lodash"

export function ReferralEntity_GetFullAddress(referralEntity) {
  return (
    (referralEntity.address ? referralEntity.address : "") +
    (referralEntity.city ? ", " + referralEntity.city : "") +
    (referralEntity.state ? ", " + referralEntity.state : "") +
    (referralEntity.zip ? ", " + referralEntity.zip : "")
  )
}

export function getDistance(fromLong, fromLat, toLong, toLat, units, rounding) {
  const options = { units: units ? units : "miles" }

  let x = distance(
    turfPoint([fromLong, fromLat]),
    turfPoint([toLong, toLat]),
    options
  )

  x = Math.round(x * 100) / 100

  return x
}

export function MapBox_Places_GetCoordinates(searchlocation, apiKey) {
  const mapBoxKey = apiKey

  if (mapBoxKey !== undefined) {
    let apiURL =
      "https://api.mapbox.com/geocoding/v5/mapbox.places/{SEARCH}.json?access_token={ACCESS_TOKEN}&limit={RESULT_LIMIT}"

    apiURL = apiURL.replace("{ACCESS_TOKEN}", mapBoxKey)
    apiURL = apiURL.replace("{SEARCH}", searchlocation)
    apiURL = apiURL.replace("{RESULT_LIMIT}", "1")

    const Result = fetch(apiURL)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          console.error(response.statusText)
          throw response
        }
      })
      .then((json) => {
        if (!json || !json.features || !json.features.length) {
          console.error("MapBox_Places_GetCoordinates: Invalid response:")
          console.error(json)
          return undefined
        } else {
          const coordinates = {
            longitude: +json.features[0].geometry.coordinates[0],
            latitude: +json.features[0].geometry.coordinates[1],
          }
          return coordinates
        }
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })

    return Result
  } else {
    console.error("MapBox api key not found")
    return undefined
  }
}

export function MapBoxSetFocusedLocation({ focusLocation, map, markers }) {
  const markerData = []
  markerData.push({
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: [focusLocation.longitude, focusLocation.latitude],
    },
    properties: {
      name: "center",
      id: 0,
    },
  })

  const marker = {
    type: "FeatureCollection",
    features: markerData,
  }

  const layer = map.getLayer("center")
  if (layer) {
    let src = map.getSource("center")
    src.setData(marker)
  } else {
    map.loadImage("/mapbox/mapbox-marker-icon-20px-red.png", (error, image) => {
      if (error) throw error
      if (!map.hasImage("RedMarker")) {
        map.addImage("RedMarker", image)
      }
    })

    map.addLayer({
      id: "center",
      type: "symbol",
      /* Add a GeoJSON source containing place coordinates and information. */
      source: {
        type: "geojson",
        data: marker,
      },
      layout: { "icon-image": "RedMarker", "icon-allow-overlap": true },
    })
  }

  if (markers) {
    MapBoxSetMarkers({ map: map, markers: markers, focusLocation })
  }
}

export function MapBoxSetMarkers({ markers, focusLong, focusLat, map }) {
  const layer = map.getLayer("locations")
  if (layer) {
    let src = map.getSource("locations")
    src.setData(markers)
  } else {
    map.loadImage(
      "/mapbox/mapbox-marker-icon-20px-blue.png",
      (error, image) => {
        if (error) throw error
        if (!map.hasImage("BlueMarker")) {
          map.addImage("BlueMarker", image)
        }
      }
    )

    map
      .addLayer({
        id: "locations",
        type: "symbol",
        /* Add a GeoJSON source containing place coordinates and information. */
        source: {
          type: "geojson",
          data: markers,
        },
        layout: { "icon-image": "BlueMarker", "icon-allow-overlap": true },
      })
      .on("mouseenter", "locations", () => {
        map.getCanvas().style.cursor = "pointer"
      })
      .on("mouseleave", "locations", () => {
        map.getCanvas().style.cursor = ""
      })
  }
}

export function getLocalDateTimeFromIso(utcDateString, format) {
  if (!format) {
    format = { ...DateTime.DATETIME_SHORT, timeZoneName: "short" }
  }

  return DateTime.fromISO(utcDateString, { zone: "utc" })
    .toLocal()
    .toLocaleString(format)
}

export function getNotePayload(userCtx) {
  return `{"displayName": "${_.unescape(
    userCtx.session.user.staff_name_first
  )} ${_.unescape(userCtx.session.user.staff_name_last)}", "email": "${
    userCtx.session.user.staff_email_address
  }"}`
}
